import { n as normalizeComponent } from "../chunks/_plugin-vue2_normalizer-DU4iP6Vu.mjs";
const _sfc_main = {
  name: "NcVNodes",
  props: {
    /**
     * The vnodes to render
     */
    vnodes: {
      type: [Array, Object],
      default: null
    }
  },
  /**
   * The render function to display the component
   *
   * @param {Function} h The function to create VNodes
   * @return {object} The created VNode
   */
  render(h) {
    var _a, _b, _c;
    return this.vnodes || ((_a = this.$slots) == null ? void 0 : _a.default) || ((_c = (_b = this.$scopedSlots) == null ? void 0 : _b.default) == null ? void 0 : _c.call(_b));
  }
};
const _sfc_render = null;
const _sfc_staticRenderFns = null;
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  null
);
const NcVNodes = __component__.exports;
export {
  NcVNodes as default
};
